// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bAutocomplete {
  position: relative;
  display: inline-block;
}

.eAutocompleteSpinner {
  position: absolute;
  top: 8px;
  right: 5px;
}

.eAutocompleteInput {
  padding-right: 1.5rem;
}

.eAutocompleteInput::placeholder {
  font-size: 12px;
}

.mFullWidth {
  width: 100%;
}

.eShowDropdownMenu {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 340px;
  padding: 8px;
  border: 1px solid #d9e2ec;
  border-radius: 14px;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.12);

  width: max-content;
  min-width: 100%;
  max-width: 520px;
}

.eAutocompleteSchoolItem {
  padding: 0 !important;
  margin-bottom: 8px;
  border-radius: 12px;
  overflow: hidden;
}

.eAutocompleteSchoolItem:last-child {
  margin-bottom: 0;
}

.eAutocompleteEmpty {
  padding: 12px 14px;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.45;
  white-space: normal;
}

.bSchoolListItem {
  padding: 12px 14px;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  background: #ffffff;
  transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.eAutocompleteSchoolItem:hover .bSchoolListItem,
.eAutocompleteSchoolItem:focus .bSchoolListItem {
  background: #f8fbfd;
  border-color: #cfe7ef;
  box-shadow: 0 4px 14px rgba(47, 168, 211, 0.08);
}

.eSchoolListItem_wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 0;
}

.eSchoolListItem_wrapper_pic {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.eSchoolListItem_pic {
  width: 44px;
  height: 44px;
  object-fit: contain;
  padding-right: 0;
}

.eSchoolListItem_initials {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #eef6fc;
  color: #155d8c;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.eSchoolListItem_content {
  min-width: 0;
  flex: 1 1 auto;
}

.eSchoolListItem_name {
  padding-top: 0;
  font-weight: 700;
  font-size: 15px;
  line-height: 1.35;
  color: #2f3b4a;
  white-space: normal;
  overflow-wrap: anywhere;
}

.eSchoolListItem_address {
  margin-top: 4px;
  color: #7b8794;
  font-size: 12px;
  line-height: 1.35;
  white-space: normal;
  word-break: break-word;
}

.eSchoolListItem_meta {
  margin-top: 7px;
}

.eCombobox_list {
  display: block;
}

.eAutocompleteSimpleItem {
  padding: 0 !important;
  margin-bottom: 6px;
  border-radius: 10px;
  overflow: hidden;
}

.eAutocompleteSimpleItem:last-child {
  margin-bottom: 0;
}

.eAutocompleteSimpleItem__text {
  padding: 10px 14px;
  border: 1px solid #edf2f7;
  border-radius: 10px;
  background: #ffffff;
  color: #4a5568;
  font-size: 14px;
  line-height: 1.35;
  transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
  white-space: normal;
  word-break: break-word;
}

.eAutocompleteSimpleItem:hover .eAutocompleteSimpleItem__text,
.eAutocompleteSimpleItem:focus .eAutocompleteSimpleItem__text {
  background: #f8fbfd;
  border-color: #cfe7ef;
  box-shadow: 0 4px 14px rgba(47, 168, 211, 0.08);
}
`, "",{"version":3,"sources":["webpack://./src/components/Autocomplete/Autocomplete.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;;EAE9C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iFAAiF;AACnF;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iFAAiF;EACjF,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,+CAA+C;AACjD","sourcesContent":[".bAutocomplete {\n  position: relative;\n  display: inline-block;\n}\n\n.eAutocompleteSpinner {\n  position: absolute;\n  top: 8px;\n  right: 5px;\n}\n\n.eAutocompleteInput {\n  padding-right: 1.5rem;\n}\n\n.eAutocompleteInput::placeholder {\n  font-size: 12px;\n}\n\n.mFullWidth {\n  width: 100%;\n}\n\n.eShowDropdownMenu {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 340px;\n  padding: 8px;\n  border: 1px solid #d9e2ec;\n  border-radius: 14px;\n  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.12);\n\n  width: max-content;\n  min-width: 100%;\n  max-width: 520px;\n}\n\n.eAutocompleteSchoolItem {\n  padding: 0 !important;\n  margin-bottom: 8px;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.eAutocompleteSchoolItem:last-child {\n  margin-bottom: 0;\n}\n\n.eAutocompleteEmpty {\n  padding: 12px 14px;\n  color: #64748b;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.45;\n  white-space: normal;\n}\n\n.bSchoolListItem {\n  padding: 12px 14px;\n  border: 1px solid #edf2f7;\n  border-radius: 12px;\n  background: #ffffff;\n  transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.eAutocompleteSchoolItem:hover .bSchoolListItem,\n.eAutocompleteSchoolItem:focus .bSchoolListItem {\n  background: #f8fbfd;\n  border-color: #cfe7ef;\n  box-shadow: 0 4px 14px rgba(47, 168, 211, 0.08);\n}\n\n.eSchoolListItem_wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 0;\n}\n\n.eSchoolListItem_wrapper_pic {\n  width: 44px;\n  height: 44px;\n  flex: 0 0 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.eSchoolListItem_pic {\n  width: 44px;\n  height: 44px;\n  object-fit: contain;\n  padding-right: 0;\n}\n\n.eSchoolListItem_initials {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  background: #eef6fc;\n  color: #155d8c;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.eSchoolListItem_content {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.eSchoolListItem_name {\n  padding-top: 0;\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 1.35;\n  color: #2f3b4a;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.eSchoolListItem_address {\n  margin-top: 4px;\n  color: #7b8794;\n  font-size: 12px;\n  line-height: 1.35;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.eSchoolListItem_meta {\n  margin-top: 7px;\n}\n\n.eCombobox_list {\n  display: block;\n}\n\n.eAutocompleteSimpleItem {\n  padding: 0 !important;\n  margin-bottom: 6px;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.eAutocompleteSimpleItem:last-child {\n  margin-bottom: 0;\n}\n\n.eAutocompleteSimpleItem__text {\n  padding: 10px 14px;\n  border: 1px solid #edf2f7;\n  border-radius: 10px;\n  background: #ffffff;\n  color: #4a5568;\n  font-size: 14px;\n  line-height: 1.35;\n  transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.eAutocompleteSimpleItem:hover .eAutocompleteSimpleItem__text,\n.eAutocompleteSimpleItem:focus .eAutocompleteSimpleItem__text {\n  background: #f8fbfd;\n  border-color: #cfe7ef;\n  box-shadow: 0 4px 14px rgba(47, 168, 211, 0.08);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
